var React = require('react');

function StarFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.32336 1.586C7.73586 0.749329 8.92836 0.749329 9.34086 1.586L11.3059 5.56683L15.7 6.20516C16.6225 6.33933 16.9909 7.4735 16.3234 8.12433L13.1434 11.2243L13.8942 15.5993C14.0525 16.5185 13.0875 17.2193 12.2617 16.786L8.33169 14.7193L4.40253 16.786C3.57753 17.2193 2.61253 16.5193 2.76919 15.5993L3.52003 11.2243L0.340859 8.12433C-0.326641 7.47433 0.0416929 6.33933 0.964193 6.20516L5.35836 5.56683L7.32336 1.586Z","fill":"#FFEB9D"}));
}

StarFilled.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = StarFilled;

StarFilled.default = StarFilled;
